import PropTypes from 'prop-types';
import { vars } from '@etg/wings';
import { ToggleBar } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { NUMBER_OF_STOPS } from '../../../../../constants/searchFiltersConstants';
import { SelectedFilters } from '../../../constants/resultPropTypes';
import Filter from '../Filter';

const toggleBarStyles = css`
  label {
    background-color: #fff;
    border-color: ${vars.colors.inputs.main};
    color: ${vars.colors.inputs.main};
    padding: 12px 10px;
    text-align: center;

    &.selectedOption {
      background-color: ${vars.colors.inputs.main};
      border-color: ${vars.colors.inputs.main};
      color: #fff;
      z-index: 1;
    }

    & > span {
      display: none;
    }

    &:not(:first-child) {
      border-left-width: 1px;
      margin-left: -1px;

      html[dir='rtl'] & {
        border-right-width: 1px;
      }
    }

    /* stylelint-disable no-descending-specificity */
    html[dir='rtl'] & {
      padding: 12px 10px;
    }
  }
`;

const getToggleBarOption = (label, value, name) => ({
  dataTestId: `${NUMBER_OF_STOPS}-${name}`,
  id: `${NUMBER_OF_STOPS}_${name}`,
  label,
  value,
});

const NumberOfStops = ({
  className,
  isInitiallyExpanded,
  isToggleable,
  onFilter,
  selectedFilters,
}) => {
  const { t } = useTranslation();
  const selectedValue =
    selectedFilters[NUMBER_OF_STOPS] === null ? '-1' : selectedFilters[NUMBER_OF_STOPS];

  const options = [
    getToggleBarOption(t('Result.SearchFilters.NumberOfStops.Direct.Button'), '0', 'direct'),
    getToggleBarOption(t('Result.SearchFilters.NumberOfStops.Max1.Button'), '1', 'max1'),
    getToggleBarOption(t('Result.SearchFilters.NumberOfStops.All.Button'), '-1', 'all'),
  ];

  const handleChange = (value) => onFilter({ [NUMBER_OF_STOPS]: value === '-1' ? null : value });

  const handleReset = () => onFilter({ [NUMBER_OF_STOPS]: null });

  return (
    <Filter
      className={className}
      isInitiallyExpanded={isInitiallyExpanded}
      isSelected={selectedValue !== '-1'}
      isToggleable={isToggleable}
      label={t('Air.Filter.Group.Stops')}
      name={NUMBER_OF_STOPS}
      onReset={handleReset}
    >
      <ToggleBar
        className={toggleBarStyles}
        inputName={NUMBER_OF_STOPS}
        onValueChange={handleChange}
        options={options}
        selectedValue={selectedValue}
        size="large"
      />
    </Filter>
  );
};

NumberOfStops.propTypes = {
  className: PropTypes.string,
  isInitiallyExpanded: PropTypes.bool,
  isToggleable: PropTypes.bool,
  onFilter: PropTypes.func,
  selectedFilters: SelectedFilters,
};

export default NumberOfStops;
